/*
 * @Author: bbqin
 * @Date: 2022-08-11 10:30:24
 * @LastEditTime: 2022-08-29 15:50:32
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\FastExtend\model\single.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import * as constant from '../const';
import * as log from '../utils/log';
import { getObjectType } from '../utils/type';

// NCCExtend
const DefaultExtendModuleName = constant.name;

// 空方法
const EmptyFunction = constant.emptyFunction;

/**
 * 获取校验后的方法
 * @param {*} obj 
 * @param {*} name 
 * @param {*} defaultf 
 * @returns 
 */
const getCheckedMethod = function (obj, name, defaultf = EmptyFunction) {
    return obj && typeof obj[name] === 'function' ? obj[name] : (defaultf || EmptyFunction);
};

/**
 * 是否包含扩展的方法
 * @param {*} obj 
 * @param {*} name 
 * @returns 
 */
export const hasExtendMethod = function (obj, name) {
    if (name === 'templateAlreadyLoaded') {
        log.blue('二开相关回调方法', constant, name);
    }
    // 有些特殊情况 取不到this对象上的方法
    if (obj && (!obj[DefaultExtendModuleName] || !Object.keys(obj[DefaultExtendModuleName]).length)) {
        obj = window;
    }
    return obj && obj[DefaultExtendModuleName] && typeof obj[DefaultExtendModuleName][name] === 'function';
};

/**
 * 旧版本的兼容
 * @param {*} obj 
 * @param {*} name 
 * @param {*} defaultf 
 * @returns 
 */
export const compatibleCheckedMethod = function (obj, name, defaultf = EmptyFunction) {
    if (name === 'templateAlreadyLoaded') {
        log.blue('二开相关回调方法', constant, name);
    }
    // 有些特殊情况 取不到this对象上的方法
    if (obj && (!obj[DefaultExtendModuleName] || !Object.keys(obj[DefaultExtendModuleName]).length)) {
        obj = window;
    }
    return obj && obj[DefaultExtendModuleName] ? getCheckedMethod(obj[DefaultExtendModuleName], name, defaultf) : (defaultf || EmptyFunction);
};

// 默认扩展开发事件的和领域事件的执行顺序
const DefaultFxConfig = {
    onAfterEvent: 'after', // after before replace remian
    onBeforeEvent: 'before',
    onEditTableAfterEvent: 'after', // after before replace remian
    onEditTableBeforeEvent: 'before',
    onFormAfterEvent: 'after', // after before replace remian
    onFormBeforeEvent: 'before',
    onCardTableAfterEvent: 'after', // after before replace remian
    onCardTableBeforeEvent: 'before',
};


/**
 * 旧版本兼容
 * @param {*} scope 
 * @param {*} info 
 * @param {*} fy 
 * @param {*} fx 
 * @returns 
 */
export const compatibleBeforeAndAfter = function (scope, info = {}, fy, fx) {

    //有些特殊情况 取不到this对象上的方法
    if (scope && (!scope[DefaultExtendModuleName] || !Object.keys(scope[DefaultExtendModuleName]).length)) {
        scope = window;
    }

    if (!scope[DefaultExtendModuleName] || !info || !info['attrcode'] || !info['fxType']) {
        return fy();
    }
    let { attrcode, moduleId = '', fxType = 'onAfterEvent', fxParams = {} } = info,
        fe = scope[DefaultExtendModuleName],
        fxConfig = {
            ...DefaultFxConfig,
            ...(fe['defaultFxConfig'] || {}),
            ...(fe[moduleId + '-' + attrcode] || {})
        };
    // 获取对应的回调方法
    fx = fx || compatibleCheckedMethod(scope, fxType);
    // console.log(fxConfig, info, fe['defaultFxConfig']);
    if (fxConfig[fxType] === 'mixin') {
        return fx(fxParams, fy);
    } else if (fxConfig[fxType] === 'replace') {
        return fx(fxParams);
    } else if (fxConfig[fxType] === 'before') {
        const orderResult = fx(fxParams); // 可以考虑添加异步处理
        if (getObjectType(orderResult) === 'AsyncFunction') {
            return new Promise(resolve => {
                orderResult().then(data => {
                    fy();
                    resolve(data);
                });
            });
        } else if (getObjectType(orderResult) === 'Promise') {
            return new Promise(resolve => {
                orderResult.then(data => {
                    fy(); // 这里也可能是异步关系
                    resolve(data);
                });
            });
        } else {
            return fy();
        }
    } else {
        const orderResult = fy(); // 可以考虑添加异步处理
        if (getObjectType(orderResult) === 'AsyncFunction') {
            return new Promise(resolve => {
                orderResult().then(data => {
                    fx(fxParams);
                    resolve(data);
                });
            });
        } else if (getObjectType(orderResult) === 'Promise') {
            return new Promise(resolve => {
                orderResult.then(data => {
                    fx(fxParams); // 这里也可能是异步关系
                    resolve(data);
                });
            });
        } else {
            return fx(fxParams);
        }
    }
};